module.exports = __webpack_public_path__ + "static/gold-ef71bb453d78c5b8a2bb5a02dd61ac59.png";